<template>
  <SearchedUserMinimum :tenantUser="expert" />
</template>

<script>
  import SearchedUserMinimum from '@modules/search/searched-user-minimum'

  export default {
    name: 'SearchedUserSimple',
    components: {
      SearchedUserMinimum,
    },
    props: {
      expert: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
  }
</script>
